import apiClient, { unwrap } from './client';

// Backend uses `amount`; frontend uses `qtyKg`
function toFrontend(record) {
  return { ...record, qtyKg: record.amount ?? record.qtyKg ?? 0 };
}

function toRequest(record) {
  const { qtyKg, ...rest } = record;
  return { ...rest, amount: qtyKg };
}

export const feedApi = {
  getAll: async () => {
    const res = await apiClient.get('/feed-records', { params: { size: 1000, sort: 'date,desc' } });
    const page = unwrap(res);
    return (page?.content ?? page ?? []).map(toFrontend);
  },

  create: async (record) => {
    const res = await apiClient.post('/feed-records', toRequest(record));
    return toFrontend(unwrap(res));
  },

  update: async (id, record) => {
    const res = await apiClient.put(`/feed-records/${id}`, toRequest(record));
    return toFrontend(unwrap(res));
  },

  remove: async (id) => {
    await apiClient.delete(`/feed-records/${id}`);
  },
};
